import { gql } from "@apollo/client";

export const SIGN_UP = gql`
mutation SignUp($email: String) {
  signUp(email: $email) {
    token
    user {
      id
      firebaseUserId
      token
      email
      userType
      isActive
      verified
      ApprovePrivacyPolicy
      createdAt
    }
    success
    message
  }
}
`;

export const VERIFY_OTP = gql`
mutation VerifyOtp($email: String, $otp: Number, $ApprovePrivacyPolicy: Boolean) {
  verifyOtp(email: $email, otp: $otp, ApprovePrivacyPolicy: $ApprovePrivacyPolicy) {
    token
    user {
      id
      firebaseUserId
      token
      email
      userType
      isActive
      verified
      ApprovePrivacyPolicy
    }
    success
    message
  }
}
`
export const SIGN_UP_WITH_GOOGLE_OR_FACEBOOK = gql`
mutation SignUpWithGoogleOrFacebook($input: signUpWithGoogleOrFacebookInput) {
  signUpWithGoogleOrFacebook(input: $input) {
    _id
    token
    name
    email
    password
    verified
    userType
    isDeleted
    isActive
    createdAt
  }
}
`

export const UPDATE_MOBILE = gql`
mutation MobileNumberUpdateUser($mobileNumberUpdateUserId: ID!, $mobile: String!) {
  mobileNumberUpdateUser(id: $mobileNumberUpdateUserId, mobile: $mobile) {
    success
    message
  }
}
`

export const CREATE_BANK_DETAILS = gql`
mutation CreateBankDetails($input: BankDetailsInput) {
  createBankDetails(input: $input) {
    status
    message
  }
}
`

export const UPDATE_USER_DETAILS = gql`
mutation UpdateUser($input: userInputData) {
  updateUser(input: $input) {
    success
    message
  }
}
`